/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fertilizer_NewInputs */

const vi_fertilizer_new = /** @type {(inputs: Fertilizer_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm phân bón`)
};

/**

* @param {Fertilizer_NewInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const fertilizer_new = /** @type {((inputs?: Fertilizer_NewInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fertilizer_NewInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_fertilizer_new(inputs)
});